/**
 * Append query params to url string
 * @param url URL
 * @param queryParams Query params
 * @returns New URL string
 * @example
 *  appendQueryObjectToURL("https://lorem.ipsum", {"foo": "bar"});
 *  // => https://lorem.ipsum/?foo=bar
 *  appendQueryObjectToURL("https://lorem.ipsum/?dolar=sit", {"foo": "bar"});
 *  // => https://lorem.ipsum/?dolar=sit&foo=bar
 */
export const appendQueryObjectToURL = (
	url: string,
	queryParams: Record<string, number | string>,
) => {
	const _url = new URL(url);
	Object.entries(queryParams).forEach(([key, value]) =>
		_url.searchParams.append(key, value.toString()),
	);
	return _url.toString();
};

export default appendQueryObjectToURL;
